<template>
  <hm-content title>
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addLivePlan"
        >创建直播计划</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planTitle"
          label="计划标题"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNum"
          label="商品数"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="计划ID"
        ></el-table-column> -->
        <!-- <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="可售门店"
          >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.shopName" placement="left">
              <span class="text-overflow">{{
                scope.row.shopName
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="300"
        >
          <template slot-scope="scope">
            <div class="flex item-center flex-start flex-wrap">
              <el-button type="text" size="small" @click="createUrl(scope.row)"
                >直播计划链接</el-button
              >
              <el-button type="text" size="small" @click="productQrcode(scope.row)"
              >直播计划二维码</el-button
              >
              <el-button type="text" size="small" @click="editGoods(scope.row)"
              >商品管理</el-button
              >
              <el-button type="text" size="small" @click="editPlan(scope.row)"
              >编辑</el-button
              >
              <el-button type="text" size="small" @click="queryDetails(scope.row)" v-if="scope.row.selectOrderMode==='quick'"
              >快捷下单链接</el-button
              >
              <!-- <el-button type="text" size="small" @click="deletePlan(scope.row)"
              >删除</el-button
              > -->
            </div>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination mb20">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="livePlanTitle"
      :visible.sync="createRankDialogVisible"
      :close-on-click-modal="false"
    >
      <div>
        <p class="paragraph">
          复制链接粘贴:
        </p>
        <div>
          <div class="link">{{ rankUrl }}</div>
          <input
            class="copy-ipt"
            type="text"
            :value="rankUrl"
            ref="activityListUrl"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="copyUrl" type="primary" size="small"
          >复制链接</el-button
        >
        <el-button size="small" @click="createRankDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="请用微信扫一扫"
        :visible.sync="qrcodeDialogVisible"
        :modal="false"
        :width="copyPath?'600px':'250px'"
      >
        <div class="qrcode-wrapper">
          <img style="width: 210px" :src="activityCode" alt="二维码" />
        </div>
        <template v-if="copyPath">
          <div>
            <p class="paragraph">
            复制链接粘贴:
          </p>
          <div>
            <div class="link">{{ copyPath }}</div>
            <input
              class="copy-ipt"
              type="text"
              :value="copyPath"
              ref="activityListUrl"
            />
          </div>
          </div>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="copyUrl" type="primary" size="small"
              >复制链接</el-button
            >
            <el-button size="small" @click="qrcodeDialogVisible = false"
              >关闭</el-button
            >
          </span>
        </template>
      </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
import { getLoginUser, getUserName } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      rankUrl: "",
      currentRow: "",
      list: [],
      total: 0,
      createRankDialogVisible: false,
      storeCode: "",
      qrcodeDialogVisible: false,
      activityCode: "",
      livePlanTitle: "直播计划地址",
      copyPath: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.queryList();    
  },
  mounted() {},
  methods: {
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy");
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },
    addLivePlan(){
      this.$router.push({ 
        name: "LivePlanDetail",
        query: {
          type: "add",
          showGoods: "no",
        } 
      });
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryLivePlanList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      });
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async deletePlan(row) {
      await this.$store.dispatch("deleteLiveRoom", {
        Id: row.Id
      });
      this.$message({
        type: "success",
        message: "删除成功"
      });
      this.queryList();
    },
    async editPlan(row) {
      this.$router.push({ 
        name: "LivePlanDetail",
        query: {
          id: row.id,
          type: "edit",
          showGoods: "no",
        } 
      });
    },
    /**
     * @desc 根据id查询详情
    */
    async queryDetails(row) {
      let min = ""
      let max = ""
      let wxshopSpuName = ""
      let wxshopSpuId = ""
      let size = ""
      const { result } = await this.$store.dispatch("queryByIdLivePlan", {
        id: row.id,
      });
      max = result.maxSelectPayAmount
      min = result.minSelectPayAmount
      wxshopSpuId = result.selectWxshopSpuId
      let wxshopSkuId = result.selectWxshopSkuId
      //  获取商品信息
      this.$store.dispatch('spuDetail', {
          storeCode: this.storeCode,
          wxshopSpuId: result.selectWxshopSpuId,
        }).then(res => {
          wxshopSpuName = res.result.wxshopSpuName
          // 获取商品规格
          this.$store.dispatch('skuSpecDetail', {
            storeCode: this.storeCode,
            wxshopSpuId: result.selectWxshopSpuId
          }).then(res2 => {
            Object.keys(res2.result.skuData).forEach(v => {
              if(res2.result.skuData[v].wxshopSkuId == result.selectWxshopSkuId) {
                size = v
              }
            })
            this.handleShowLink(row, min, max, wxshopSpuId, wxshopSpuName, size, wxshopSkuId)
          })
      })
    },
    /**
     * @desc 展示快捷下单弹窗
     * @param {Object} row 
     * @param {Object} min 最小金额
     * @param {Object} max 最大金额
     * @param {Object} wxshopSpuId 商品id
     * @param {Object} wxshopSpuName 商品名称
     * @param {Object} size 商品规格
    */
    async handleShowLink(row, min, max, wxshopSpuId, wxshopSpuName, size, wxshopSkuId) {
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      console.log(min, max, wxshopSpuId, wxshopSpuName, size, wxshopSkuId);
      let params = {
        path: `quickOrder/index?wxshopSpuId=${wxshopSpuId}&wxshopSpuName=${wxshopSpuName}&min=${min}&max=${max}&size=${size}&wxshopSkuId=${wxshopSkuId}`,
        // path: `live/livePlan?wxshopSpuId=29a96fadd6ad4f5bbd5f6505c1b37e62&wxshopSpuName=小丸子小丸子小丸子&min=10&max=100&size=100ML`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "快捷下单二维码",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `quickOrder/index?saveUUID=${url.result}`,
        storeCode: row.storeCode,
      });
      this.copyPath = `quickOrder/index?wxshopSpuId=${wxshopSpuId}&wxshopSpuName=${wxshopSpuName}&min=${min}&max=${max}&size=${size}&wxshopSkuId=${wxshopSkuId}`
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    async productQrcode(row) {
      // const { storeCode } = getToken();
      // console.log("getToken(): ", getToken());
      this.copyPath = ""
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `live/livePlan?id=${row.id}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "直播计划二维码",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `live/livePlan?saveUUID=${url.result}`,
        storeCode: row.storeCode,
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    createUrl(row){
      this.rankUrl = "live/livePlan?id=" + row.id;   
      this.createRankDialogVisible = true;   
    },
    editGoods(row){
      this.$router.push({ 
        name: "LivePlanDetail",
        query: {
          id: row.id,
          type: "edit",
          showGoods: "yes",
        } 
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.status {
  &.playing {
    color: #f72c2c;
  }
  &.not-start {
    color: #0282e6;
  }
  &.end {
    color: #999;
  }
}

.video-list {
  video {
    width: 200px;
    margin-right: 20px;
  }
}

.copy-ipt {
  position: fixed;
  left: -100vw;
}

.link {
  margin-top: 30px;
}

.qrcode-wrapper {
  text-align: center;
  img {
    width: 100%;
  }
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
